import axios from 'axios';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_API_URL;


const api = axios.create({
    baseURL: BASE_URL,
});

let token = window.sessionStorage.getItem('token');

api.interceptors.request.use(
    (config) => {
        // Do something before request is sent
        // Añadir header para token
        //X-User-Token
        if (token) {
            config.headers['X-User-Token'] = token;
        } else {
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return console.error(error);
    }
);

api.interceptors.response.use(
    (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function async(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        const errorResp = error.response.data;

        toast(errorResp.mensaje, {
            toastId: errorResp.codigo,
            type: 'error',
        });

        if (error.response.status === 499) {
            toast('No hay acceso al servidor de INAVI', {
                toastId: 'error499',
                type: 'error',
            });
        }

        switch (errorResp.codigo) {
            //Errores de Autentificacion
            case 'TOK02':
                window.location.href = '/login';
                window.sessionStorage.clear();
                break;

            case 'TOK03':
                window.location.href = '/login';
                window.sessionStorage.clear();
                break;

            default:
                console.log('Interceptor: ', error);
                break;
        }

        return Promise.reject(error);
    }
);

const { get, post, put, delete: destroy } = api;
export { get, post, put, destroy };
